type FeedbackOption = 'PREFER_THE_OLD_DESIGN' | 'COULD_NOT_FIND_CONTENT' | 'HARD_TO_NAVIGATE' | 'TECHNICAL_ISSUES' | 'SLOW_TO_LOAD' | 'OTHER';

type Step = 'options' | 'comment' | 'submitting' | 'error';

type FeedbackOptionData = {
  value: FeedbackOption;
  label: string;
};

type WhyLeavingProps = React.ComponentProps<'div'> & {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

type OptionsProps = React.ComponentProps<'div'> & {
  options: FeedbackOptionData[];
  selectedOption: FeedbackOption | null;
  onOptionClick: (option: FeedbackOption) => void;
  title: string;
};

type CommentProps = React.ComponentProps<'div'> & {
  selectedLabel: string | undefined;
  comment: string;
  onCommentChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  title: string;
  commentsLabel: string;
  submitButtonText: string;
};

const STEPS = {
  OPTIONS: 'options',
  COMMENT: 'comment',
  SUBMITTING: 'submitting',
  ERROR: 'error',
} as const;

export { STEPS, type CommentProps, type FeedbackOption, type FeedbackOptionData, type OptionsProps, type Step, type WhyLeavingProps };
